import React from "react";
import { Reveal, Label } from "./anim";
import { DUAL } from "../data/content";
import { ArrowLeftRight } from "lucide-react";

export const DualPerspective = () => {
  return (
    <section
      data-testid="dual-section"
      className="relative bg-[#E7E2D2] py-24 md:py-40 overflow-hidden border-y border-[#16281C]/10"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <Label>Dual Perspective</Label>
          <h2 className="mt-6 font-display font-semibold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] max-w-4xl text-[#16281C]">
            I've worked <span className="text-[#2C5F3A]">both sides</span> of the counter.
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-24 grid lg:grid-cols-[1fr_auto_1fr] gap-8 lg:gap-6 items-stretch">
          <Reveal delay={0.05}>
            <div className="h-full bg-[#FAF8F1] border border-[#16281C]/12 p-8 md:p-12 hover:border-[#2C5F3A]/40 transition-colors">
              <p className="font-mono text-xs tracking-[0.2em] uppercase text-[#66766A]">
                {DUAL.left.tag}
              </p>
              <h3 className="mt-6 font-display font-semibold text-2xl md:text-3xl tracking-tight text-[#16281C]">
                {DUAL.left.title}
              </h3>
              <p className="mt-5 font-body text-base md:text-lg text-[#4C5C50] leading-relaxed">
                {DUAL.left.body}
              </p>
            </div>
          </Reveal>

          <div className="flex lg:flex-col items-center justify-center gap-4 py-4">
            <div className="hidden lg:block w-px flex-1 bg-gradient-to-b from-transparent via-[#2C5F3A] to-transparent" />
            <div className="w-14 h-14 border border-[#2C5F3A] text-[#2C5F3A] flex items-center justify-center bg-[#E7E2D2]">
              <ArrowLeftRight size={20} />
            </div>
            <div className="hidden lg:block w-px flex-1 bg-gradient-to-b from-[#2C5F3A] via-[#2C5F3A] to-transparent" />
          </div>

          <Reveal delay={0.15}>
            <div className="h-full bg-[#2C5F3A] text-[#EFEBDE] p-8 md:p-12">
              <p className="font-mono text-xs tracking-[0.2em] uppercase text-[#EFEBDE]/60">
                {DUAL.right.tag}
              </p>
              <h3 className="mt-6 font-display font-semibold text-2xl md:text-3xl tracking-tight">
                {DUAL.right.title}
              </h3>
              <p className="mt-5 font-body text-base md:text-lg text-[#EFEBDE]/85 leading-relaxed">
                {DUAL.right.body}
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
